import { IIconProps } from './constants';

export const LockIcon = ({ height = 24, width = 24 }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.49298 4.03844C10.1579 3.37354 11.0597 3 12 3C12.9403 3 13.8421 3.37354 14.507 4.03844C15.1719 4.70334 15.5454 5.60514 15.5454 6.54545V9.18182H8.45454V6.54545C8.45454 5.60514 8.82808 4.70334 9.49298 4.03844ZM6.45454 9.18182V6.54545C6.45454 5.07471 7.03879 3.6642 8.07877 2.62423C9.11874 1.58425 10.5292 1 12 1C13.4707 1 14.8812 1.58425 15.9212 2.62423C16.9612 3.6642 17.5454 5.07471 17.5454 6.54545V9.18182H18.3636C19.9201 9.18182 21.1818 10.4436 21.1818 12V18.3636C21.1818 19.9201 19.9201 21.1818 18.3636 21.1818H5.63636C4.07992 21.1818 2.81818 19.9201 2.81818 18.3636V12C2.81818 10.4436 4.07992 9.18182 5.63636 9.18182H6.45454ZM16.5454 11.1818H7.45454H5.63636C5.18449 11.1818 4.81818 11.5481 4.81818 12V18.3636C4.81818 18.8155 5.18449 19.1818 5.63636 19.1818H18.3636C18.8155 19.1818 19.1818 18.8155 19.1818 18.3636V12C19.1818 11.5481 18.8155 11.1818 18.3636 11.1818H16.5454Z"
      clipRule="evenodd"
      fillRule="evenodd"
      className="fill-current"
    />
  </svg>
);
